import ChromeIcon from 'images/chrome-icon.svg'
import EdgeIcon from 'images/edge-icon.svg'
import FirefoxIcon from 'images/firefox-icon.svg'
import FireTVIcon from 'images/firetv-icon.svg'
import LinuxIcon from 'images/linux-icon.svg'
import MacOSIcon from 'images/macos-icon.svg'
import AndroidIcon from 'images/download-page/android.svg'
import IosIcon from 'images/download-page/ios.svg'
import WindowsIcon from 'images/windows-platform-icon.svg'

export interface DownloadPlatforms {
  [key: string]: {
    icon: React.ElementType
    name: string
    learnMoreUrl: string
    installGuideUrl: string
    sourceCodeUrl: string
    downloadOptions?: {
      name: string
      downloadUrl: string
    }[]
    downloadUrl: string
  }
}

export const platforms: DownloadPlatforms = {
  Windows: {
    icon: WindowsIcon,
    name: 'Windows',
    learnMoreUrl: '/features/windows',
    installGuideUrl: '/knowledge-base/articles/getting-started-with-windscribe-on-windows',
    sourceCodeUrl: 'https://github.com/Windscribe/Desktop-App',
    downloadOptions: [
      {
        name: '64-bit (AMD64)',
        downloadUrl: '/install/desktop/windows',
      },
      {
        name: '64-bit (ARM)',
        downloadUrl: '/install/desktop/windows_arm64',
      },
      {
        name: '32-bit (Legacy)',
        downloadUrl: 'https://assets.totallyacdn.com/desktop/win/Windscribe_2.4.exe',
      },
    ],
    downloadUrl: '/install/desktop/windows',
  },
  MacOS: {
    icon: MacOSIcon,
    name: 'MacOS',
    learnMoreUrl: '/features/macos',
    installGuideUrl: '/knowledge-base/articles/getting-started-with-windscribe-on-macos',
    sourceCodeUrl: 'https://github.com/Windscribe/Desktop-App',
    downloadOptions: [
      {
        name: 'Universal',
        downloadUrl: '/install/desktop/osx',
      },
      {
        name: 'Legacy',
        downloadUrl: 'https://assets.totallyacdn.com/desktop/mac/Windscribe-legacy.dmg',
      },
    ],
    downloadUrl: '/install/desktop/osx',
  },
  Linux: {
    icon: LinuxIcon,
    name: 'Linux',
    learnMoreUrl: '/features/linux',
    installGuideUrl: '/knowledge-base/articles/how-to-set-up-windscribe-on-linux',
    sourceCodeUrl: 'https://github.com/Windscribe/Desktop-App',
    downloadOptions: [
      {
        name: 'Debian/Ubuntu (AMD64)',
        downloadUrl: '/install/desktop/linux_deb_x64',
      },
      {
        name: 'Fedora/CentOS (AMD64)',
        downloadUrl: '/install/desktop/linux_rpm_x64',
      },
      {
        name: 'Arch (AMD64)',
        downloadUrl: '/install/desktop/linux_zst_x64',
      },
      {
        name: 'Debian/Ubuntu (AARCH64)',
        downloadUrl: ' /install/desktop/linux_deb_arm64',
      },
      {
        name: 'Linux openSUSE (AMD64)',
        downloadUrl: '/install/desktop/linux_rpm_opensuse_x64',
      },
      {
        name: 'Linux CLI Debian/Ubuntu (AMD64)',
        downloadUrl: '/install/desktop/linux_deb_x64_cli',
      },
      {
        name: 'Linux CLI Debian/Ubuntu (ARM64)',
        downloadUrl: '/install/desktop/linux_deb_arm64_cli',
      },
      {
        name: 'Linux CLI Fedora/CentOS (AMD64)',
        downloadUrl: '/install/desktop/linux_rpm_x64_cli',
      },
      {
        name: 'Linux CLI Arch (AMD64)',
        downloadUrl: '/install/desktop/linux_zst_x64_cli',
      },
      {
        name: 'Linux CLI openSUSE',
        downloadUrl: '/install/desktop/linux_rpm_opensuse_x64_cli',
      },
    ],
    downloadUrl: '',
  },
  Chrome: {
    icon: ChromeIcon,
    name: 'Chrome',
    learnMoreUrl: '/features/chrome',
    installGuideUrl: '/knowledge-base/articles/how-to-use-with-windscribe-on-chrome',
    sourceCodeUrl: 'https://github.com/Windscribe/browser-extension',
    downloadUrl: '/install/extension/chrome',
  },
  Firefox: {
    icon: FirefoxIcon,
    name: 'Firefox',
    learnMoreUrl: '/features/firefox',
    installGuideUrl: '/knowledge-base/articles/getting-started-with-windscribe-on-firefox',
    sourceCodeUrl: 'https://github.com/Windscribe/browser-extension',
    downloadUrl: '/install/extension/firefox',
  },
  Edge: {
    icon: EdgeIcon,
    name: 'Edge',
    learnMoreUrl: '/features/edge',
    installGuideUrl: '/knowledge-base/articles/getting-started-with-windscribe-on-microsoft-edge ',
    sourceCodeUrl: 'https://github.com/Windscribe/browser-extension',
    downloadUrl: '/install/extension/edge',
  },
  Android: {
    icon: AndroidIcon,
    name: 'Android',
    learnMoreUrl: '/features/android',
    installGuideUrl: '/knowledge-base/articles/how-to-install-windscribe-on-android',
    sourceCodeUrl: 'https://github.com/Windscribe/Android-App',
    downloadUrl: '/install/mobile/android',
  },
  iOS: {
    icon: IosIcon,
    name: 'iOS',
    learnMoreUrl: '/features/ios',
    installGuideUrl: '/knowledge-base/articles/getting-started-with-windscribe-on-ios',
    sourceCodeUrl: '',
    downloadUrl: '/install/mobile/ios',
  },
  FireTV: {
    icon: FireTVIcon,
    name: 'FireTV',
    learnMoreUrl: '',
    installGuideUrl: '/knowledge-base/articles/how-to-set-up-windscribe-on-a-firetv-firestick',
    sourceCodeUrl: 'https://github.com/Windscribe/Android-App',
    downloadUrl: '/install/mobile/android-direct-tv',
  },
  AndroidTV: {
    icon: AndroidIcon,
    name: 'AndroidTV',
    learnMoreUrl: '',
    installGuideUrl:
      '/knowledge-base/articles/how-to-set-up-windscribe-on-android-tv-nvidia-shield-devices',
    sourceCodeUrl: 'https://github.com/Windscribe/Android-App',
    downloadUrl: '/install/mobile/android-direct-tv',
  },
  AppleTV: {
    icon: IosIcon,
    name: 'AppleTV',
    learnMoreUrl: '/features/ios',
    installGuideUrl: '/knowledge-base/articles/getting-started-with-windscribe-on-ios',
    sourceCodeUrl: '',
    downloadUrl: '/install/mobile/ios',
  },
}
